// @flow
const initialState = {
  key: '',
  name: '',
  description: '',
};
export default initialState;